import { createFileRoute } from "@tanstack/react-router";
import { Box, Skeleton } from "@salestrak/ui";
import { PageHeader, PageHeaderTitle, SettingsBackBar, SettingsBackBarClearance } from "#app/components/page-header";
import { useApiKeys, useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { useAppData } from "#app/lib/data";
import { ApiKeyDetailView } from "#app/components/settings/api-key-detail-view";
import { ApiKeyRevokeDialog } from "#app/components/settings/api-key-revoke-dialog";
import { useState } from "react";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { SettingsPageSkeleton } from "#app/components/settings/settings-page-skeleton";

function AccessDetailPage() {
  const { apiKeyId } = Route.useParams();
  const { push, replace } = useAppNavigate();
  const { currentUser } = useAppData();
  const { apiKeys, isLoading } = useApiKeys(currentUser?.userId);
  const { revokeApiKey } = useApiKeyMutations();

  const [showRevoke, setShowRevoke] = useState(false);

  const apiKey = apiKeys.find((k: any) => k.apiKeyId === apiKeyId);

  if (isLoading && !apiKey) {
    return (
      <Box direction="column" fill="flex" position="relative">
        {/* Real chrome: back bar + header geometry hold through the resolve;
          * only the key name is a bar. The settled Details card is 2 rows. */}
        <SettingsBackBar label="API" onClick={() => replace("/settings/access")} />
        <Box fill="flex" overflow="auto">
          <SettingsBackBarClearance />
          <PageHeader centered pinnedBack>
            <PageHeaderTitle>
              <Skeleton delayed height={20} width={180} />
            </PageHeaderTitle>
          </PageHeader>
          <SettingsPageSkeleton groups={[{ rows: 3 }]} />
        </Box>
      </Box>
    );
  }

  if (!apiKey) {
    replace("/settings/access");
    return null;
  }

  async function handleRevoke() {
    await revokeApiKey(apiKeyId);
    replace("/settings/access");
  }

  return (
    <>
      <ApiKeyDetailView
        apiKey={apiKey}
        onBack={() => replace("/settings/access")}
        onEdit={() =>
          push(`/settings/access/${apiKeyId}/edit`)
        }
        onRevoke={() => setShowRevoke(true)}
      />

      <ApiKeyRevokeDialog
        open={showRevoke}
        onOpenChange={(open) => { if (!open) setShowRevoke(false); }}
        apiKeyName={apiKey.name}
        onConfirm={handleRevoke}
      />
    </>
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/access/$apiKeyId/",
)({ component: AccessDetailPage });
